import { render, staticRenderFns } from "./course-settings-basic.vue?vue&type=template&id=97df3332&"
import script from "./course-settings-basic.vue?vue&type=script&lang=ts&"
export * from "./course-settings-basic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports